import { useContext } from 'react'
import { Context } from './Page'

const usePageContext = () => {
    return useContext(Context)
}
export default usePageContext
